// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22TTL","label":"styles_label__1KSCO"};